import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider as ToastRootProvider,
  ToastTitle,
  ToastViewport,
} from './toast';
import { useToastState } from '@/hooks/useToast';

export function Toaster() {
  const { toasts } = useToastState();
  return (
    <ToastRootProvider>
      {toasts.map(({ id, title, description, action, ...props }) => (
        <Toast key={id} {...props}>
          <div className="grid gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
          </div>
          {action}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastRootProvider>
  );
}
